export default __webpack_public_path__ + "static/NBInternationalPro-Medium-5b0ae5b6c99605dc0fe68d830f77978b.otf";